import './BodyMedium01.scss';
import clsx from 'clsx';
import React, { ComponentPropsWithoutRef, ElementType, PropsWithChildren } from 'react';

type PolymorphicProps<E extends ElementType> = PropsWithChildren<ComponentPropsWithoutRef<E> & {
  as?: E;
}>;

type Props <T extends React.ElementType> = PolymorphicProps<T> & PropsWithChildren<{
  className?: string;
}>;

export const BodyMedium01 = <T extends ElementType = 'p'>(
  { className, as, children, ...props }: Props<T>,
): React.ReactElement => {
  const Component = as || 'p';

  return (
    <Component className={clsx('bp-body-medium-01', className)} {...props}>
      {children}
    </Component>
  );
};
